export const signupreq="signupreq"
export const signupsucc="signupsucc"


export const signupfail="signupfail"
